module.exports = __webpack_public_path__ + "static/media/195.de1d7871.jpg";